import script from "./CMO.vue?vue&type=script&lang=js"
export * from "./CMO.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__